import React, { ReactNode } from 'react'


import {
  SectionContent,
  SectionHeader,
  SectionAction,
  SectionTitle,
} from './styles'

interface IActionsProps {
  title: string
  isDisabled?: boolean
  onPress?: () => void
}

interface ISectionProps {
  title: string
  children: ReactNode
  actions?: IActionsProps[]
  leftElement?: ReactNode
}

export function Section({ title, children, actions, leftElement }: ISectionProps) {
  return (
    <SectionContent>
      <SectionHeader>
        {leftElement}
        <SectionTitle>{title}</SectionTitle>

        {actions && actions?.length > 0 && (
          <>
            {actions.map((action, index) => (
              <button
                key={index}
                disabled={action.isDisabled}
                onClick={action.onPress}
                style={{ background: 'none', border: 'none', cursor: action.isDisabled ? 'not-allowed' : 'pointer', padding: '8px 4px', minHeight: 44, display: 'flex', alignItems: 'center' }}
              >
                <SectionAction isEnabled={!action.isDisabled}>
                  {action.title}
                </SectionAction>
              </button>
            ))}
          </>
        )}
      </SectionHeader>

      {children}
    </SectionContent>
  )
}
